import { Routes } from '@angular/router';
import {
  ASSESSMENT_ID_PATH_PARAM,
  ASSESSMENT_LIST_PATH,
  HOME_PATH,
  THERAPIST_ID_PATH_PARAM,
  THERAPIST_PATH,
} from '../../../../../values/path';
import { IsLoggedInGuard } from '../../../../../../sdk/src/lib/guards/is-logged-in.guard';
import { HasChangedInitialPasswordAdmin } from '../../../../../../sdk/src/lib/guards/has-changed-initial-password-admin.guard';
import { IsUserWithAdminPrivilegesGuard } from '../../../../../../sdk/src/lib/guards/is-user-with-admin-privileges.guard';
import { AuthGuard } from '@auth0/auth0-angular';

export const FULL_ROUTES: Routes = [
  {
    path: `${ASSESSMENT_LIST_PATH}`,
    loadComponent: () =>
      import('../../components/assessment-list/assessment-list.component').then(
        (assessmentModule) => assessmentModule.AssessmentListComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
  {
    path: `${ASSESSMENT_LIST_PATH}/:${ASSESSMENT_ID_PATH_PARAM}`,
    loadComponent: () =>
      import('../../components/assessment-view/assessment-view.component').then(
        (assessmentViewModule) => assessmentViewModule.AssessmentViewComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
  {
    path: HOME_PATH,
    loadComponent: () =>
      import('../../components/home/home.component').then(
        (homeModule) => homeModule.HomeComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
  {
    path: `${THERAPIST_PATH}`,
    loadComponent: () =>
      import('../../components/therapist/therapist.component').then(
        (therapistModule) => therapistModule.TherapistComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
  {
    path: `${THERAPIST_PATH}/:${THERAPIST_ID_PATH_PARAM}`,
    loadComponent: () =>
      import('../../components/therapist-view/therapist-view.component').then(
        (therapistViewModule) => therapistViewModule.TherapistViewComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
  {
    path: `${THERAPIST_PATH}/:${THERAPIST_ID_PATH_PARAM}/${ASSESSMENT_LIST_PATH}/:${ASSESSMENT_ID_PATH_PARAM}`,
    loadComponent: () =>
      import('../../components/assessment-view/assessment-view.component').then(
        (assessmentViewModule) => assessmentViewModule.AssessmentViewComponent
      ),
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordAdmin,
      IsUserWithAdminPrivilegesGuard,
    ],
  },
];
